import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TableModule } from 'primeng-lts/table';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { DirectivesModule } from '../../directives/directives.module';
import { TenderRequestedMaterialComponent } from './TenderRequestedMaterial.component';
import { AwardRequestedMaterialListComponent } from './AwardRequestedMaterialList.component';
import { AwardRequestedMaterialComponent } from './AwardRequestedMaterial.component';
import { ContractRequestedMaterialComponent } from './ContractRequestedMaterial.component';
import { TenderRequestedMaterialListComponent } from './TenderRequestedMaterialList.component';
import { ContractRequestedMaterialListComponent } from './ContractRequestedMaterialList.component';



@NgModule({
  declarations: [AwardRequestedMaterialListComponent,
    TenderRequestedMaterialListComponent,
    TenderRequestedMaterialComponent,
    AwardRequestedMaterialComponent,
    ContractRequestedMaterialComponent,
    ContractRequestedMaterialListComponent],
  imports: [WaitLoadingModule, // Servicio  de espera
    TranslateModule,   // Servicio de internacionalización
    CommonModule,
    TableModule,
    DirectivesModule,  // Directivas para dobleclick de botones, autofocus, ...
    OverlayPanelModule,
    TableModule,
    PanelModule,
    FormPlycaModule,
    ScrollPanelModule,
    SubHeaderModule]
})

export class RequestedMaterialModule { }
